import { render } from "./MLClassSelect.vue?vue&type=template&id=39fa8aef"
import script from "./MLClassSelect.vue?vue&type=script&lang=js"
export * from "./MLClassSelect.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__